import React from 'react'
import { IRequestInformation } from '../../../models/Enquiry'
import { onKeyPressHandler } from '../../../utilities/commonFunctions'

export interface IEnquiryRequestForInformationRowProps {
  item: IRequestInformation
  displayForm: (id: IRequestInformation) => void
}
const EnquiryRequestForInformationRow = (

  
  props: IEnquiryRequestForInformationRowProps
) => (
  <tr key={props.item?.id}>
    <td key={props.item?.id}>
      <a
        role="button"
        tabIndex={0}
        onKeyPress={onKeyPressHandler}
        onClick={() => props.displayForm(props.item)}
      >
        {props.item?.subject}
      </a>
    </td>
    <td>{props.item?.responded}</td>
    <td>{props.item?.createdOn}</td>
  </tr>
)

export default EnquiryRequestForInformationRow
